
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(152|676|860|986)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
